"use client";
import { Mail, Phone, MapPin } from "lucide-react";
import { useState } from "react";
import { CONTACT_PHONE_DISPLAY } from "@/lib/contactInfo";

// (framer-motion removed) static rendering

const channels = [
  { icon: Mail, title: 'Email', value: 'youthinnovationacademy@gmail.com', desc: 'We reply within 24h on weekdays.' },
  { icon: Phone, title: 'Phone', value: CONTACT_PHONE_DISPLAY, desc: 'Mon – Fri, 10:00 am – 08:00 pm' },
  { icon: MapPin, title: 'Location', value: 'Fida hussain, Shaheed Ahmed St, Nasirabad Mariabad, Quetta, 87000, Pakistan', desc: 'Distributed learning network.' },
];

export default function Contact() {
  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <section id="contact" className="relative py-10 ">
      {/* Background gradient */}
     
      <div className="max-w-2xl mx-auto text-center mb-16">
        <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-brand-gradient">Get In Touch</h2>

        <p className="mt-5 text-base md:text-lg text-white/70 leading-relaxed">Questions, partnerships, cohort inquiries — reach out through any channel below. We keep it lightweight: no contact form, just direct lines.</p>
      </div>
      <div className="relative justify-center items-center lg:flex gap-10 mx-auto px-6 md:px-10">


        {/* Direct channels (no cards) */}
        <div className="mt-10 grid gap-6 sm:grid-cols-2 w-full lg:w-1/2" role="list">
          {channels.map((c) => {
            const Icon = c.icon; return (
              <div key={c.title} role="listitem" className="flex items-start gap-4">
                <div className="mt-0.5 w-10 h-10 rounded-xl flex items-center justify-center  ">
                  <Icon className="w-5 h-5 text-brand" />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold tracking-wide text-brand uppercase">{c.title}</div>
                  <div className="text-brand-alt text-sm font-medium break-words">{c.value}</div>
                  <div className="text-white text-xs leading-relaxed">{c.desc}</div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Lazy-loaded map with facade */}
        <div className="rounded-2xl mt-10 lg:mt-0 overflow-hidden border border-[color-mix(in_srgb,var(--brand)_25%,var(--blue-border))] bg-[rgba(255,255,255,0.03)] w-full lg:w-1/2">
          <div className="h-80 w-full relative">
            {!mapLoaded && (
              <button
                onClick={() => setMapLoaded(true)}
                className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-slate-800 to-slate-900 text-white hover:from-slate-700 hover:to-slate-800 transition-colors cursor-pointer group"
                aria-label="Load interactive map"
                >
                <div className="text-center">
                  <MapPin className="w-12 h-12 mx-auto mb-3 text-brand group-hover:scale-110 transition-transform" />
                  <p className="text-sm font-medium">Click to load map</p>
                </div>
              </button>
            )}
            {mapLoaded && (
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3448.953201729704!2d67.03173247535041!3d30.18133077485492!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ed2dfcccd286d27%3A0xa8bfef28856515e4!2sAral%20studio!5e0!3m2!1sen!2s!4v1757246357503!5m2!1sen!2s" 
                width="600" 
                height="500" 
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Youth Innovation Academy Location"
                className="w-full h-full"
              />
            )}
          </div>
        </div>



      </div>
    </section>
  );
}